export const HOTSPOT_EXPLORER_ROUTE = '/hotspot-explorer';
export const HOTSPOT_EXPLORER_DETAIL_ROUTE = `${HOTSPOT_EXPLORER_ROUTE}/hotspot`;
export const HOTSPOT_EXPLORER_PAGE_SIZE = 50;
export const HOTSPOT_EXPLORER_PAGE_PARAM = 'page';
export {
    LIST_BUILDING_CHECKLIST_DATE,
    LIST_BUILDING_CHECKLIST_DATE_LABEL
} from "../../helpers/constants";

export const HOTSPOT_SORT_VISITS = 'visits';
export const HOTSPOT_SORT_SPECIES = 'species';
export const HOTSPOT_SORT_RECENT = 'recent';

export const HOTSPOT_SORT_OPTIONS = [
    { value: HOTSPOT_SORT_VISITS, label: 'Most Visited' },
    { value: HOTSPOT_SORT_SPECIES, label: 'Most Species' },
    { value: HOTSPOT_SORT_RECENT, label: 'Most Recent' }
] as const;
